import {
  TResource,
  resourceCategory,
  resourceEduCode,
  resourceVersion,
} from '~/api/oneBoxV3/oneBoxV3.type';

import { SearchCategory } from '~/types/enum';

export type TSearchCondition = {
  categories: SearchCategory;
  versions: resourceVersion | null | 'all';
  eduCodes: resourceEduCode | null | 'all';
  years: string | null;
  grades: string | null;
  subjects: string | null;
  // sidebars: SIDEBAR;
  resources1: string | null;
  resources2: string | null;
  resources3: string | null;
  fuzzySearch: string | null;
  fuzzySearchFields: string[] | null;
  isLaunch: boolean;
  dateFrom: string | null;
  dateTo: string | null;
  page: number;
  pageSize: number;
  sort: string;
};

export enum FileStatus {
  non = 'non',
  progressing = 'progressing',
  paused = 'paused',
  /**
   * @description 下載完成
   */
  completed = 'completed',
  cancel = 'cancel',
  installing = 'installing',
  /**
   * @description 整個流程完成
   */
  finish = 'finish',
}

export type TDownloadItem = {
  filename: string;
  url: string;
  status: FileStatus;
  fileSize: number;
  bytes: number;
  remainingBytes: number;
  dist: string;
  updateTime: number;
  installingProgress: number;
  downloadedAt: number;
};

export type TDownloadList = {
  [id: string]: { [fileFormat: string]: TDownloadItem };
};

export type TProgressItem = {
  downloaded: string;
  downloadedBytes: number;
  filename: string;
  name: string;
  progress: number;
  remaining: string;
  remainingBytes: number;
  speed: string;
  speedBytes: number;
  total: string;
  totalBytes: number;
  url: string;
};

export type TProgressList = [string, TProgressItem][];

export type TResourceState = {
  searchCondition: TSearchCondition;
  resources: TResource[];
  downloadList: TDownloadList;
  progressList: TProgressList;
  totalDownloadingList: {
    label: string;
    subLabel: string;
    lastLabel: string;
  }[];
  baseDownloadPath: string;
  totalResourcesCount: number;
  resourceBookId: string;
  knowledgeChaptersList: [];
};

export type TResourceProgress = {
  status: FileStatus;
  fileFormat?: string;
  filePath?: string;
  progressRatio: number;
  speedBytes: number;
  speed: string;
  totalBytes: number;
  total: string;
  downloaded: string;
  downloadedBytes: number;
  key?: string;
  updateTime: number;
  installingProgressRatio: number;
  downloadedAt?: number;
};

export type THistoryItem = {
  fileName: string;
  fileFormat: string;
  progress: number;
  size: string;
  url: string;
  key: string;
  status: FileStatus;
  downloadedAt: number;
  updateTime: number;
  totalBytes: number;
};

export type TDownloadListItem = {
  path: string;
  fileFormat: string;
} & TDownloadItem;

type TOriginAdditionalPair<T> = { origin: T; additional: string[] };

export type TAdminResource = {
  _id: string;
  originalFileId: string;
  createdAt: string;
  isLaunch: boolean;
  url: string;
  fileName: string;
  displayName: string;
  categories: {
    origin: resourceCategory;
    additional: resourceCategory[];
  };
  eduCodes: {
    origin: resourceEduCode;
    additional: resourceEduCode[];
  };
  grades: TOriginAdditionalPair<string>;
  resources1: TOriginAdditionalPair<string | undefined>;
  resources2: TOriginAdditionalPair<string | undefined>;
  resources3: TOriginAdditionalPair<string | undefined>;
  subjects: TOriginAdditionalPair<string>;
  versions: {
    origin: resourceVersion;
    additional: resourceVersion[];
  };
  years: TOriginAdditionalPair<string>;
  chapterKeyword: TOriginAdditionalPair<string | undefined>;
  knowledge: TOriginAdditionalPair<string | undefined>;
};

export type TAdminState = {
  category: resourceCategory;
  resources: TAdminResource[];
};
